import { gql } from 'graphql-tag'
import { reminderFragment } from '../admin/reminders/RemindersQueries'
import { userFragment } from '../admin/users/usersQueries'
import { companyFragment } from '../company/companyQueries'

const efficiencyFactorFragment = gql`
  fragment EfficiencyFactorFragment on EfficiencyFactor {
    month
    efficiencyFactor
  }
`

const efficiencyFactorGroupFragment = gql`
  fragment EfficiencyFactorGroupFragment on EfficiencyFactorGroup {
    id
    type
    name
    efficiencyFactors {
      ...EfficiencyFactorFragment
    }
  }
  ${efficiencyFactorFragment}
`

const buffetWeightFragment = gql`
  fragment BuffetWeightFragment on BuffetWeight {
    startTime
    endTime
    weight
  }
`

export const stationFragment = gql`
  fragment StationFragment on Station {
    id
    name
    address
    salesIncentiveUnit
    buffetGroup
    buffetBeginAt
    buffetEndAt
    buffetWeights {
      weekday {
        ...BuffetWeightFragment
      }
      friday {
        ...BuffetWeightFragment
      }
      saturday {
        ...BuffetWeightFragment
      }
      sunday {
        ...BuffetWeightFragment
      }
    }
    company {
      ...CompanyFragment
    }
    users {
      ...UserFragment
    }
    reminders {
      ...ReminderFragment
    }
    deactivated
  }
  ${buffetWeightFragment}
  ${companyFragment}
  ${userFragment}
  ${reminderFragment}
`

export const hesburgerEfficiencyBoundaryFragment = gql`
  fragment HesburgerEfficiencyBoundaryFragment on HesburgerEfficiencyBoundary {
    ipShare
    avgPurchase
    salesMargin
    productWastage
    raWastage
    inventoryDifferences
    intakes
    readinessCheeseBurger
    readinessDoubleBurger
    readinessCampaign
  }
`

export const fetchStationList = gql`
  query FetchStationList($after: String, $first: Int) {
    stations(after: $after, first: $first) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const fetchStation = gql`
  query FetchStation($id: ID!) {
    station(id: $id) {
      ...StationFragment
    }
  }
  ${stationFragment}
`

export const updateStation = gql`
  mutation UpdateStation($id: ID!, $data: UpdateStationInput!) {
    updateStation(stationId: $id, station: $data) {
      ...StationFragment
    }
  }
  ${stationFragment}
`

export const addStationUser = gql`
  mutation AddStationUser($stationId: ID!, $userId: ID!) {
    connectUserStation(userId: $userId, stationId: $stationId) {
      id
      user {
        ...UserFragment
      }
      station {
        ...StationFragment
      }
    }
  }
  ${userFragment}
  ${stationFragment}
`

export const removeStationUser = gql`
  mutation RemoveStationUser($stationId: ID!, $userId: ID!) {
    removeUserStation(userId: $userId, stationId: $stationId)
  }
`

export const fetchEfficiencyFactors = gql`
  query EfficiencyFactors($stationId: ID!) {
    efficiencyFactors(stationId: $stationId) {
      ...EfficiencyFactorGroupFragment
    }
  }
  ${efficiencyFactorGroupFragment}
`

export const upsertEfficiencyFactors = gql`
  mutation UpsertEfficiencyFactors($id: ID!, $efficiencyFactors: [EfficiencyFactorInput]!) {
    upsertEfficiencyFactors(id: $id, efficiencyFactors: $efficiencyFactors) {
      ...EfficiencyFactorFragment
    }
  }
  ${efficiencyFactorFragment}
`

export const fetchOpeningTimes = gql`
  query fetchOpeningTimes($stationId: ID!) {
    openingTimes(stationId: $stationId) {
      id
      weekDay
      startTime
      endTime
    }
  }
`

const nightTaskFragment = gql`
  fragment NightTaskFragment on NightTask {
    id
    name
  }
`

export const fetchNightTasks = gql`
  query FetchStationNightTasks($stationId: ID!) {
    stationNightTasks(stationId: $stationId) {
      ...NightTaskFragment
    }
  }
  ${nightTaskFragment}
`

export const fetchAvailableNightTasks = gql`
  query FetchAvailableNightTasks($stationId: ID!) {
    availableNightTasks(stationId: $stationId) {
      ...NightTaskFragment
    }
  }
  ${nightTaskFragment}
`

export const createNightTask = gql`
  mutation CreateNightTask($stationId: ID!, $name: String!) {
    createNightTask(stationId: $stationId, name: $name) {
      ...NightTaskFragment
    }
  }
  ${nightTaskFragment}
`

export const updateNightTask = gql`
  mutation UpdateNightTask($nightTaskId: ID!, $name: String!) {
    updateNightTask(nightTaskId: $nightTaskId, name: $name) {
      ...NightTaskFragment
    }
  }
  ${nightTaskFragment}
`

export const deleteNightTask = gql`
  mutation DeleteNightTask($nightTaskId: ID!) {
    deleteNightTask(nightTaskId: $nightTaskId)
  }
`

export const fetchHesburgerEfficiencyBoundary = gql`
  query HesburgerEfficiencyBoundary($stationId: ID!) {
    hesburgerEfficiencyBoundary(stationId: $stationId) {
      ...HesburgerEfficiencyBoundaryFragment
    }
  }
  ${hesburgerEfficiencyBoundaryFragment}
`
export const upsertHesburgerEfficiencyBoundary = gql`
  mutation UpsertHesburgerEfficiencyBoundary($stationId: ID!, $boundary: UpsertHesburgerEfficiencyBoundaryInput!) {
    upsertHesburgerEfficiencyBoundary(stationId: $stationId, data: $boundary) {
      ...HesburgerEfficiencyBoundaryFragment
    }
  }
  ${hesburgerEfficiencyBoundaryFragment}
`
